import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Article = Styled.article`
max-width: 45rem;
background-color: ${(props) =>
  props.selected ? color.secondaryAlt : color.white} !important;
display: grid;
grid-template-columns: 10rem 65fr 15rem;
place-content: center;
place-items: center;
border-radius: 4px;
cursor: pointer;
color: ${color.primary};
margin: 0.5rem 0;
&:hover{background-color: ${color.lightAlt}}
`;

const ArticleIcon = Styled.span`
height: 5rem;
width: 5rem;
border-radius: 100rem;
display: block;
background-color: ${color.light};
img{width: 100%; height: 100%; object-fit: cover};
`;

const ArticleText = Styled.div`
background-color: transparent;
`;

const ArticlePrice = Styled.span`
border-left: 1px solid ${color.lightAlt};
padding: 2.5rem 2rem;
font-size: 1.3rem;
max-width: 16ch;
em{
display: block;
font-weight: 600;
font-size: 3rem;
font-style: normal;
};
`;

const ArticleHeading = Styled.h3`
margin-bottom:1rem;`;

const ArticleParagraph = Styled.p`
font-size: 1.6rem;
`;

const TextAreaFilled = ({
  icon,
  title,
  paragraph,
  price,
  brief,
  onClick,
  selected,
}) => {
  return (
    <Article
      selected={selected}
      onClick={() => {
        onClick(title);
      }}>
      <ArticleIcon>
        <img src={icon} alt="" />
      </ArticleIcon>
      <ArticleText>
        <ArticleHeading>{title}</ArticleHeading>
        <ArticleParagraph>{paragraph}</ArticleParagraph>
      </ArticleText>
      <ArticlePrice>
        <em>${price}</em>
        {brief}
      </ArticlePrice>
    </Article>
  );
};

export default TextAreaFilled;
